import { createFileRoute } from '@tanstack/react-router';
import TestDetailPage from '@/pages/(protected)/workspaces/[workspaceId]/compliance/tests/[testId]';

type TestDetailSearch = {
  from?: 'tasks' | 'tests' | 'controls' | 'framework';
  view?: 'tests' | 'controls';
  frameworkId?: string;
  frameworkName?: string;
  controlDefId?: string;
  controlDisplayId?: string;
  tab?: string;
  // Deep-link target: scrolls to + highlights this auditor comment thread.
  commentId?: string;
  // RFC-226 deep-link target: scrolls to + highlights this auditor proposal
  // (the ProposedTest key the notification names).
  proposalKey?: string;
  // #1418 — deep-link target: scrolls to + highlights this open finding
  // (RemediationTicket id) in TestOpenFindingsSection.
  highlightFinding?: string;
  // Opens the matching API-run evidence dialog on arrival.
  apiRunId?: string;
  // Packed filter state of the Tests list we came from, so the "Tests"
  // breadcrumb returns to the same filtered view. See lib/tests-list-filters.
  listFilters?: string;
};

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/tests_/$testId/'
)({
  component: TestDetailPage,
  validateSearch: (search: Record<string, unknown>): TestDetailSearch => {
    return {
      from: search.from as TestDetailSearch['from'],
      view: search.view as TestDetailSearch['view'],
      frameworkId: search.frameworkId as string | undefined,
      frameworkName: search.frameworkName as string | undefined,
      controlDefId: search.controlDefId as string | undefined,
      controlDisplayId: search.controlDisplayId as string | undefined,
      tab: search.tab as string | undefined,
      commentId: search.commentId as string | undefined,
      proposalKey: search.proposalKey as string | undefined,
      highlightFinding: search.highlightFinding as string | undefined,
      apiRunId: search.apiRunId as string | undefined,
      listFilters: search.listFilters as string | undefined,
    };
  },
});
